const pad = (n: number): string => String(n).padStart(2, '0');

export function toISO(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Parst YYYY-MM-DD als lokales Datum (12 Uhr, damit Zeitumstellungen nicht stören). */
export function fromISO(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d, 12);
}

export function todayISO(): string {
  return toISO(new Date());
}

export function addDays(s: string, n: number): string {
  const d = fromISO(s);
  d.setDate(d.getDate() + n);
  return toISO(d);
}

/** Anzahl Tage von a nach b (b - a). */
export function diffDays(a: string, b: string): number {
  return Math.round((fromISO(b).getTime() - fromISO(a).getTime()) / 86_400_000);
}

export function formatDayHeading(s: string): string {
  return fromISO(s)
    .toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: 'short' })
    .toUpperCase();
}

export function formatLong(s: string): string {
  return fromISO(s).toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
}

export function freqLabel(weeks: number): string {
  return weeks === 1 ? '1 Woche' : `${weeks} Wochen`;
}
